export function isRouteActive(
  pathname: string,
  href: string,
  matcher?: string | ((pathname: string) => boolean)
): boolean {
  if (typeof matcher === 'function') {
    return matcher(pathname);
  }

  if (typeof matcher === 'string') {
    const regex = new RegExp(matcher);
    return regex.test(pathname);
  }

  // Handle external URLs - extract pathname from full URL
  if (href.startsWith('http://') || href.startsWith('https://')) {
    try {
      const url = new URL(href);
      const externalPath = url.pathname;
      // Check if current pathname matches the external path
      if (pathname === externalPath || pathname.includes(externalPath)) {
        return true;
      }
    } catch {
      // If URL parsing fails, fall through to normal matching
    }
  }

  const homeRegex = /^\/org\/\d+$/;
  if (homeRegex.test(href)) {
    return homeRegex.test(pathname);
  }

  return pathname.includes(href);
}
